// default navicon
export function navicon() {
    document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
        e.preventDefault();
        e.currentTarget.classList.toggle('site-navigation__navicon--active');
        document.querySelector('.site-navigation').classList.toggle('site-navigation--active');
        document.body.classList.toggle('site-navigation--open');
    });
}

document.addEventListener('DOMContentLoaded', () => {
		

});